/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatthinking1Inputs */

const en_chatthinking1 = /** @type {(inputs: Chatthinking1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`thinking`)
};

const pt_chatthinking1 = /** @type {(inputs: Chatthinking1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a pensar`)
};

/**
* | output |
* | --- |
* | "thinking" |
*
* @param {Chatthinking1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatthinking1 = /** @type {((inputs?: Chatthinking1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatthinking1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatthinking1(inputs)
	return pt_chatthinking1(inputs)
});
export { chatthinking1 as "chatThinking" }